import { ActionTypes } from "../../constants/ActionTypes";
import { IRecentNews, IAutomationStatistics } from "../../interfaces";

// recent news
export const onGetRecentNews = () => {
    return {
        type: ActionTypes.GET_RECENT_NEWS,
    };
};

export const fetchRecentNewsSuccess = (recentNews: IRecentNews[]) => {
    return {
        type: ActionTypes.FETCH_RECENT_NEWS_SUCCESS,
        payload: recentNews,
    };
};

// automation statistics
export const onGetAutomationStatistics = () => {
    return {
        type: ActionTypes.GET_AUTOMATION_STATISTICS
    };
};

export const fetchAutomationStatisticsSuccess = (automationStatistics: IAutomationStatistics) => {
    return {
        type: ActionTypes.FETCH_AUTOMATION_STATISTICS_SUCCESS,
        payload: automationStatistics,
    };
};